var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1263 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1051 118h-2c-78-37-160-62-245-77-2-2-4 0-4 0-12 21-22 44-31 64-92-14-185-14-277 0-8-20-19-43-31-64 0 0-2-2-4 0-84 15-167 40-245 77h-2C54 352 11 580 31 806c0 0 0 2 2 2 91 68 194 120 303 153 0 2 2 0 4 0 22-33 43-66 61-101 0-2 0-4-2-6-33-13-65-27-94-46-2 0-4-4 0-6 6-4 12-8 18-14h4c198 90 412 90 607 0h4c6 6 12 10 18 14 3 2 3 6 0 6-30 19-61 33-94 46-2 2-2 4-2 6 18 35 39 68 62 101 2 0 2 2 4 0 109-33 211-85 302-153 2 0 2-2 2-2 25-261-43-487-179-688zM430 669c-59 0-109-56-109-122 0-68 50-121 109-121 62 0 109 53 109 121 0 66-49 122-109 122zm401 0c-60 0-107-56-107-122 0-68 47-121 107-121 62 0 111 53 109 121 0 66-47 122-109 122z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDiscord);
export default __webpack_public_path__ + "static/media/ic_discord.2654acea4ec442a6303da046a93e2050.svg";
export { ForwardRef as ReactComponent };